import {useEffect} from 'react'

const HEADER_WRAPPER_SELECTOR = '.js-header-wrapper'

type UseNavPaddingRecalculationArgs = {
  headerRef: React.RefObject<HTMLElement | null>
  headerMenuRef: React.RefObject<HTMLElement | null>
  isOpen: boolean
}

/** Keeps the viewport-fixed mobile menu below the visible in-flow header, including banners and titles. */
export function useNavPaddingRecalculation({headerRef, headerMenuRef, isOpen}: UseNavPaddingRecalculationArgs): void {
  useEffect(() => {
    if (!isOpen) return
    const header = headerRef.current
    const headerMenu = headerMenuRef.current
    if (!header || !headerMenu) return

    const recalculateNavPadding = () => {
      headerMenu.style.setProperty('padding-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`)
    }
    let frame = 0
    const scheduleRecalculation = () => {
      cancelAnimationFrame(frame)
      frame = requestAnimationFrame(recalculateNavPadding)
    }

    const resizeObserver = new ResizeObserver(scheduleRecalculation)
    resizeObserver.observe(header)
    const wrapper = header.closest(HEADER_WRAPPER_SELECTOR)
    if (wrapper) resizeObserver.observe(wrapper)
    recalculateNavPadding()

    // eslint-disable-next-line github/prefer-observers
    window.addEventListener('resize', scheduleRecalculation)
    document.addEventListener('global-banner:close', scheduleRecalculation)

    return () => {
      cancelAnimationFrame(frame)
      resizeObserver.disconnect()
      window.removeEventListener('resize', scheduleRecalculation)
      document.removeEventListener('global-banner:close', scheduleRecalculation)
    }
  }, [isOpen, headerRef, headerMenuRef])
}
